import { render, staticRenderFns } from "./SpendingTracker.vue?vue&type=template&id=67d34edc&scoped=true&"
import script from "./SpendingTracker.vue?vue&type=script&lang=js&"
export * from "./SpendingTracker.vue?vue&type=script&lang=js&"
import style0 from "./SpendingTracker.vue?vue&type=style&index=0&id=67d34edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d34edc",
  null
  
)

export default component.exports